import styles from "./styles.module.scss";
import Section from "../../components/Section";

import img1 from "../../images/1.png";
import img2 from "../../images/2.png";
import img3 from "../../images/3.png";
import img4 from "../../images/4.png";
import img5 from "../../images/5.png";
import img6 from "../../images/6.png";

import e_image from "../../images/e.png";

const WorkFields = () => {
  return (
    <Section>
      <div className={styles.container}>
        <h1 className={styles.title}>СФЕРА ДЕЯТЕЛЬНОСТИ</h1>
        <div className={styles.items}>
          <div className={styles.item}>
            <div>
              <img src={img1} alt="1" />
            </div>
            <p>Логотипы</p>
          </div>
          <div className={styles.item}>
            <div>
              <img src={img2} alt="2" />
            </div>
            <p>Векторная графика</p>
          </div>
          <div className={styles.item}>
            <div>
              <img src={img3} alt="3" />
            </div>
            <p>Растровая графика</p>
          </div>
          <div className={styles.item}>
            <div>
              <img src={img4} alt="4" />
            </div>
            <p>Веб-дизайн</p>
          </div>
          <div className={styles.item}>
            <div>
              <img src={img5} alt="5" />
            </div>
            <p>Анимация</p>
          </div>
          <div className={styles.item}>
            <div>
              <img src={img6} alt="6" />
            </div>
            <p>3D-графика</p>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default WorkFields;
